function decodePayload(token: string | undefined | null): Record<string, unknown> | null {
  if (!token) return null;
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return null;
    return JSON.parse(atob(parts[1]!.replace(/-/g, "+").replace(/_/g, "/")));
  } catch {
    return null;
  }
}

// Decode role from a Supabase JWT (access_token). Trusts that the token has
// already been signature-verified by Supabase Auth — we only need the claim.
export function roleFromAccessToken(token: string | undefined | null): string | null {
  const payload = decodePayload(token);
  if (!payload) return null;
  const appMeta = payload.app_metadata as { role?: string } | undefined;
  return appMeta?.role ?? (payload.role_claim as string | undefined) ?? null;
}

// Authenticator Assurance Level from the JWT. Supabase issues:
//   aal1 — single factor (password only)
//   aal2 — multi-factor verified (password + TOTP/etc.)
// Used to gate the admin surface on MFA verification.
export function aalFromAccessToken(token: string | undefined | null): "aal1" | "aal2" | null {
  const payload = decodePayload(token);
  if (!payload) return null;
  const aal = payload.aal;
  return aal === "aal2" ? "aal2" : aal === "aal1" ? "aal1" : null;
}
